import { z } from 'zod'
import { baseModelShape } from '../baseModel'

const userShape = {
  id: z.string().uuid(),
  email: z.string().email(),
  first_name: z.string(),
  last_name: z.string(),
  full_name: z.string(),
}

const canvassingOrgShape = {
  id: z.string().uuid(),
  name: z.string(),
}

export const taskShape = {
  ...baseModelShape,
  id: z.string().uuid(),
  taskName: z.string(),
  description: z.string(),
  status: z.enum(['not_completed', 'completed']),
  assignee: z.object(userShape),
  assigner: z.object(userShape),
  canvassingOrg: z.object(canvassingOrgShape),
  dateTaskAssigned: z.string(),
  dateTaskCompleted: z.string().nullable(),
  dueDate: z.string().nullable(),
  urgent: z.enum(['yes', 'no']),
  important: z.enum(['yes', 'no']),
}

export const taskCreateShape = {
  task_name: z.string().min(1, 'Task name is required'),
  description: z.string().optional(),
  assignee_id: z.string().uuid('Invalid assignee'),
  canvassing_org_id: z.string().uuid().optional(),
  due_date: z.string().optional().nullable(),
  urgent: z.enum(['yes', 'no']).optional(),
  important: z.enum(['yes', 'no']).optional(),
}

export const taskUpdateShape = {
  task_name: z.string().min(1).optional(),
  description: z.string().optional(),
  status: z.enum(['not_completed', 'completed']).optional(),
  assignee_id: z.string().uuid().optional(),
  due_date: z.string().optional().nullable(),
  urgent: z.enum(['yes', 'no']).optional(),
  important: z.enum(['yes', 'no']).optional(),
}
